<template>
  <div class="wrapper">
    <ul class="wjclass">
      <li v-for="item in list" :key="item.questionnaireid" @click="push(item)">{{ item.questionnairename }}</li>
    </ul>
  </div>
</template>

<script>
import { getPapers } from "@/request/api.js";
export default {
  data(){
    return{
      list: []
    }
  },
  created() {
    this.getlist();
  },
  methods: {
    async getlist(){
      let res = await getPapers({});
      if(res.data.message == "操作成功"){
        this.list = res.data.obj;
      }
    },
    push(item){
      this.$router.push(`/questionnaireList?questionnaireId=${item.questionnaireid}`);
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .wjclass{
    display: flex;
    flex-flow: column nowrap;
    margin: 0 10px;
    >li{
      letter-spacing: 1px;
      margin-top: 10px;
      font-size: 16px;
      background: #FFF;
      border: 1px solid #ddd;
      border-radius: 6px;
      text-align: center;
      padding: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/questionnaire/questionnaire.vue